import React, { useEffect, useState, useContext } from "react";
import Gender from "./components/Gender";
import ProgressBar from "./components/ProgressBar";
import Birthday from "./components/Birthday";
import Name from "./components/Name";
import Email from "./components/Email";
import Password from "./components/Password";
import Result from "./components/Result";
import { simplyClick, getTTI, sendScreenResolution } from "./helpers";
import { events, landingId } from "./constants";
import { useAppendLandingId } from "./hooks/useAppendLandingId";
import { useSessionData } from "ui-components";
import { ContextProfileUser } from "./lib/profileContext";

function App() {
  const [step, setStep] = useState(1);
  let content = null;
  useAppendLandingId(landingId);

  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  useEffect(() => {
    if (window.location.search !== "") {
      const signInButton = document.getElementById("login");
      signInButton?.setAttribute("href", `/login/${window.location.search}`);
    }

    const element = document.getElementById("translation-checkpoint");
    if (!element) return;

    const initText = element.textContent?.trim() ?? "";
    let previousText = initText;

    const observer = new MutationObserver(() => {
      const currentText = element.textContent.trim() ?? "";
      if (currentText !== previousText && initText !== currentText) {
        simplyClick("translation_detected", {
          element: "footer_links",
          text: currentText.slice(0, 1000),
        });
        previousText = currentText;
      }
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    const timer = setTimeout(() => {
      getTTI();
      sendScreenResolution();
    }, 5000);

    return () => {
      observer.disconnect();
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    const loginButton = document.getElementById("login");
    const acceptCookies = document.querySelector(".accept");
    const clickHandlerLogin = () => {
      simplyClick(events[step]);
    };
    loginButton.addEventListener("click", clickHandlerLogin);
    return () => {
      loginButton.removeEventListener("click", clickHandlerLogin);
    };
  }, [step]);

  switch (step) {
    case 1:
      content = <Gender setStep={setStep} step={step} />;
      break;
    case 2:
      content = <Birthday setStep={setStep} step={step} />;
      break;
    case 3:
      content = <Name setStep={setStep} step={step} />;
      break;
    case 4:
      content = <Email setStep={setStep} step={step} />;
      break;
    case 5:
      content = <Password setStep={setStep} step={step} />;
      break;
    case 6:
      content = <Result />;
      break;
    default:
  }

  return (
    <>
      <ProgressBar step={step} />
      {content}
    </>
  );
}

export default App;
